module.exports = __webpack_public_path__ + "media/images/menu_icon_on-07b407dd51eace88528068dbd17619ff.gif";